document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll("[data-resources-guides]");

  if (!blocks.length) {
    return;
  }

  const getVideoEmbedUrl = (url) => {
    if (!url) {
      return null;
    }

    try {
      const parsed = new URL(url);
      const hostname = parsed.hostname.toLowerCase();
      const pathSegments = parsed.pathname
        .split("/")
        .filter((segment) => segment !== "");

      let videoId = null;
      let embedUrl = null;

      // Handle Vimeo URLs
      if (
        hostname.includes("vimeo.com") &&
        pathSegments.length > 0 &&
        pathSegments[0] !== "channels"
      ) {
        videoId = pathSegments[pathSegments.length - 1];
        if (videoId) {
          embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
        }
      } else if (hostname.includes("player.vimeo.com")) {
        if (pathSegments[0] === "video" && pathSegments[1]) {
          videoId = pathSegments[1];
          if (videoId) {
            embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
          }
        }
      }
      // Handle YouTube URLs
      else if (
        hostname.includes("youtube.com") ||
        hostname.includes("youtu.be")
      ) {
        // youtube.com/watch?v=VIDEO_ID
        if (parsed.searchParams.has("v")) {
          videoId = parsed.searchParams.get("v");
        }
        // youtu.be/VIDEO_ID
        else if (hostname.includes("youtu.be") && pathSegments.length > 0) {
          videoId = pathSegments[0];
        }
        // youtube.com/embed/VIDEO_ID
        else if (pathSegments[0] === "embed" && pathSegments[1]) {
          videoId = pathSegments[1];
        }
        // youtube.com/v/VIDEO_ID (legacy format)
        else if (pathSegments[0] === "v" && pathSegments[1]) {
          videoId = pathSegments[1];
        }

        if (videoId) {
          // Remove any additional parameters from video ID (e.g., ?t=123)
          videoId = videoId.split("?")[0].split("&")[0];
          embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        }
      }

      return embedUrl;
    } catch (error) {
      return null;
    }
  };

  const trackResourceClick = (title, url, type) => {
    if (!url || typeof window.gtag !== "function") {
      return;
    }

    if (type === "video") {
      window.gtag("event", "video_click", {
        video_title: title || url,
        video_url: url,
      });
      return;
    }

    window.gtag("event", "file_download", {
      file_name: title || url,
      link_url: url,
      link_text: title || url,
    });
  };

  blocks.forEach((block) => {
    const listContainer = block.querySelector("[data-resources-list]");
    const paginationContainer = block.querySelector(
      "[data-resources-pagination]"
    );
    const root = block.closest(".resources-guides");
    const filterSelect = root
      ? root.querySelector("[data-resources-filter]")
      : null;
    const modal = root ? root.querySelector("[data-resources-modal]") : null;
    const modalContent = modal
      ? modal.querySelector("[data-resources-modal-content]")
      : null;
    const modalClose = modal
      ? modal.querySelector("[data-resources-modal-close]")
      : null;
    const modalBackdrop = modal
      ? modal.querySelector("[data-resources-modal-backdrop]")
      : null;
    const modalDialog = modal
      ? modal.querySelector(".resources-guides-modal__dialog")
      : null;

    const ajaxUrl = block.getAttribute("data-ajax-url");
    const action = block.getAttribute("data-action");
    const nonce = block.getAttribute("data-nonce");
    const perPage = parseInt(block.getAttribute("data-per-page"), 10) || 9;

    if (
      !ajaxUrl ||
      !action ||
      !nonce ||
      !listContainer ||
      !paginationContainer
    ) {
      return;
    }

    let currentFilter = block.getAttribute("data-current-filter") || "all";
    let currentPage =
      parseInt(block.getAttribute("data-current-page"), 10) || 1;
    let isLoading = false;
    let isModalOpen = false;

    const setLoadingState = (state) => {
      isLoading = state;
      block.classList.toggle("is-loading", state);
    };

    const closeModal = () => {
      if (!modal || !modalContent || !isModalOpen) {
        return;
      }

      modal.classList.remove("is-active");
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("resources-guides-modal-open");

      const iframe = modalContent.querySelector("iframe");
      if (iframe && iframe.parentNode === modalContent) {
        iframe.remove();
      } else {
        modalContent.innerHTML = "";
      }

      if (modalDialog) {
        modalDialog.removeAttribute("aria-label");
      }

      isModalOpen = false;
      document.removeEventListener("keydown", handleKeydown);
    };

    const handleKeydown = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };

    const openModal = (url, title) => {
      if (!url) {
        return;
      }

      const embedUrl = getVideoEmbedUrl(url);

      if (!embedUrl) {
        window.open(url, "_blank", "noopener");
        return;
      }

      if (!modal || !modalContent) {
        window.open(embedUrl, "_blank", "noopener");
        return;
      }

      modalContent.innerHTML = `
        <iframe
          src="${embedUrl}"
          title="${title ? title.replace(/"/g, "&quot;") : "Video player"}"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
        ></iframe>
      `;

      if (modalDialog) {
        modalDialog.setAttribute(
          "aria-label",
          title || "Resource video player"
        );
      }

      modal.classList.add("is-active");
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("resources-guides-modal-open");

      isModalOpen = true;
      document.addEventListener("keydown", handleKeydown);
    };

    const updateMarkup = (
      itemsHtml = "",
      paginationHtml = "",
      newPage = 1,
      newFilter = currentFilter
    ) => {
      listContainer.innerHTML = itemsHtml;
      paginationContainer.innerHTML = paginationHtml;
      currentPage = newPage;
      currentFilter = newFilter;
      block.setAttribute("data-current-page", String(currentPage));
      block.setAttribute("data-current-filter", currentFilter);

      if (filterSelect && filterSelect.value !== currentFilter) {
        filterSelect.value = currentFilter;
      }
    };

    const fetchResults = (filterValue = "all", page = 1) => {
      if (isLoading) {
        return;
      }

      setLoadingState(true);

      const formData = new FormData();
      formData.append("action", action);
      formData.append("nonce", nonce);
      formData.append("filter", filterValue);
      formData.append("paged", String(page));
      formData.append("perPage", String(perPage));

      fetch(ajaxUrl, {
        method: "POST",
        credentials: "same-origin",
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
          }
          return response.json();
        })
        .then((payload) => {
          if (!payload || !payload.success) {
            throw new Error(
              payload && payload.data && payload.data.message
                ? payload.data.message
                : "Unexpected response"
            );
          }

          const data = payload.data;

          updateMarkup(
            data.items_html || "",
            data.pagination_html || "",
            data.current_page || 1,
            filterValue
          );
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error("Resources filter request failed:", error);
        })
        .finally(() => {
          setLoadingState(false);
        });
    };

    if (filterSelect) {
      filterSelect.value = currentFilter;
      filterSelect.addEventListener("change", (event) => {
        const selectedFilter = event.target.value || "all";
        fetchResults(selectedFilter, 1);
      });
    }

    paginationContainer.addEventListener("click", (event) => {
      const pageTrigger = event.target.closest("[data-page]");

      if (!pageTrigger) {
        return;
      }

      event.preventDefault();

      const page = parseInt(pageTrigger.getAttribute("data-page"), 10);

      if (!page || page === currentPage) {
        return;
      }

      fetchResults(currentFilter, page);
    });

    block.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-resource-trigger]");

      if (!trigger) {
        return;
      }

      const type = trigger.getAttribute("data-resource-type");
      const url = trigger.getAttribute("data-resource-url");
      const title = trigger.getAttribute("data-resource-title") || "";

      if (type === "file") {
        trackResourceClick(title, url, type);
        return;
      }

      if (type !== "video") {
        return;
      }

      event.preventDefault();

      trackResourceClick(title, url, type);
      openModal(url, title);
    });

    const bindModalCloseHandlers = () => {
      if (!modal) {
        return;
      }

      if (modalClose) {
        modalClose.addEventListener("click", (event) => {
          event.preventDefault();
          closeModal();
        });
      }

      if (modalBackdrop) {
        modalBackdrop.addEventListener("click", (event) => {
          event.preventDefault();
          closeModal();
        });
      }
    };

    bindModalCloseHandlers();
  });
});
